import React, { useEffect, useState } from "react";
import { toast } from "react-toastify";
import { setTitle } from "../../../../helpers/MetaTag";
import { useDebounce } from "../../../../hooks/useDebounce";
import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import { postDelete, postList, postOrdering, postStatusChange } from "../../../../services/postService";
import Badge from "../../../../components/elements/Badge";
import { getPaginationRange, handleFilterChange } from "../../../../helpers";
import Table from "../../../../components/elements/table/Table";
import Button from "../../../../components/form/Button";
import DeleteModal from "../../../../components/common/DeleteModal";
import { useNavigate } from "react-router-dom";
import dayjs from "dayjs";
import TableControls from "../../../../components/elements/TableControls";
import ActionBar from "../../../../components/elements/ActionBar";
import { status_filter } from "../../../../components/constant/constant";
import TagFilter from "../../../../components/elements/TagFilter";
import Tooltip from "../../../../components/elements/Tooltip";
import { useLoadTaxonomyList } from "../../../../helpers/GetCommonList";
import FilterTags from "../../../../components/elements/FilterTags";
import GoogleLogo from "../../../../assets/images/google_logo.png";

const Advertisement = () => {
  setTitle("Advertisement");
  const navigate = useNavigate();
  const [selectedItems, setSelectedItems] = useState([]);
  const [keyword, setKeyword] = useState("");
  const search = useDebounce(keyword, 300);
  const queryClient = useQueryClient();
  const [deleteModal, setDeleteModal] = useState({
    isOpen: false,
    data: null,
  });
  const [filters, setFilters] = useState({
    limit: 100,
    page: 1,
    sortQuery: "ordering",
    "type[0]": "post-photo",
    "type[1]": "post-video",
    adsType: ["personal", "google"],
  });

  const [selectedFilter, setSelectedFilter] = useState(null);
  const [selectFilterItem, setSelectFilterItem] = useState([]);
  const [selectedAllFilters, setSelectedAllFilters] = useState([]);
  const userLang = localStorage.getItem("lang") || "en";

  const [selectedSearchData, setSelectedSearchData] = useState({
    category: [],
  });

  const { loadTaxonomyList } = useLoadTaxonomyList();
  const [categorieslist, setCategoriesList] = useState({
    data: [],
    loading: true,
  });
  const [categoryKeyWord, setCategoryKeyWord] = useState("");

  const { data, error, isLoading, updateData, isFetching, refetch } = useQuery({
    queryKey: ["advertisement", filters, search, selectedSearchData?.category, selectFilterItem],
    queryFn: async () => {
      const payloadFilter = { ...filters };
      const adsTypeFilter = {};

      payloadFilter?.adsType?.forEach((p, i) => {
        adsTypeFilter[`adsType[${i}]`] = p;
      });

      delete payloadFilter?.adsType;

      const res = await postList({
        ...payloadFilter,
        ...adsTypeFilter,
        ...(selectedFilter === "status" && { status: selectFilterItem?.value }),
        // categories: selectedSearchData?.category,
        // ...(selectedFilter === "tags" && { tags: selectFilterItem?.value }),
        ...(selectedFilter === "dateRange" && {
          startDate: dayjs(selectFilterItem?.value?.startDate).format("YYYY-MM-DD"),
          endDate: dayjs(selectFilterItem?.value?.endDate).format("YYYY-MM-DD"),
        }),
        ...(search && { keyword: search }),
      });
      if (res?.status !== 200) {
        toast.warning(res?.message);
      }
      return res?.docs;
    },
  });

  //   Blog status change handler =================>
  const { mutate: statusChangeHandler, isPending: statusChangeInPending } = useMutation({
    mutationFn: async ({ id, status }) => {
      queryClient.setQueryData(["advertisement", filters, search, selectFilterItem], (state) => {
        if (!state) return;

        const updatedData = state?.data?.map((item) =>
          item?._id === id
            ? {
                ...item,
                status: item.status === "active" ? "inactive" : "active",
              }
            : item
        );

        return { ...state, data: updatedData };
      });
      const res = await postStatusChange({ ids: [id], status });

      return { res, payload: { id, status } };
    },

    onSuccess: ({ res, payload }) => {
      if (res?.status === 200) {
        toast.success("Ad status change successfully.");
        queryClient.refetchQueries(["advertisement", filters, search, selectFilterItem]);
      } else {
        queryClient.setQueryData(["advertisement", filters, search, selectFilterItem], (state) => {
          if (!state) return;

          const revertedData = state?.data?.map((item) =>
            item?._id === payload.id
              ? {
                  ...item,
                  status: item.status === "active" ? "inactive" : "active",
                }
              : item
          );

          return { ...state, data: revertedData };
        });

        toast.error(res?.message || "Failed to update status.");
      }
    },

    onError: (error) => {
      toast.error(error?.message || "Something went wrong while updating status.");
      console.error("Status update error:", error);
    },
  });

  const tableHeadData = [
    {
      _id: 1,
      name: "Ads",
      align: "left",
    },
    {
      _id: 2,
      name: "Title",
      align: "left",
      isSort: true,
      onSort: (val) => {
        if (val === "DESC") {
          setFilters((pre) => ({ ...pre, sortQuery: "-title" }));
        } else {
          setFilters((pre) => ({ ...pre, sortQuery: "title" }));
        }
      },
    },
    // {
    //   _id: 3,
    //   name: "Categories",
    //   align: "left",
    //   isSearchFilter: false,
    //   onSearchFilter: (val) => {
    //     console.log(val, "select value");
    //     if (val?.length > 0) {
    //       setSelectedSearchData({
    //         category: val,
    //       });
    //     } else {
    //       setSelectedSearchData({
    //         category: [],
    //       });
    //     }
    //   },
    //   isOption: "select",
    //   searchData:
    //     categorieslist?.data?.map((it) => ({
    //       name: it?.title,
    //       value: it?._id,
    //     })) || [],
    //   keywordSearch: (val) => {
    //     setCategoryKeyWord(val);
    //   },
    // },
    {
      _id: 13,
      name: "For",
      align: "left",
      isFilter: true,
      isFilterSearch: false,
      onFilter: (val) => {
        if (val?.length > 0 && val?.length === 1) {
          setFilters((pre) => {
            const rest = Object.fromEntries(Object.entries(pre).filter(([key]) => !key.startsWith("adsType[")));

            return {
              ...rest,
              adsType: [val?.map((item) => item?.value)],
            };
          });
        } else {
          setFilters((pre) => ({
            ...pre,
            adsType: ["google", "personal"],
          }));
        }
      },
      filterData:
        [
          { name: "Google", value: "google", type: "checkbox" },
          { name: "Personal", value: "personal", type: "checkbox" },
        ] || [],
    },
    // {
    //   _id: 10,
    //   name: "Artist",
    //   align: "center",
    // },
    {
      _id: 4,
      name: "Publish Date",
      align: "left",
      isSort: true,
      onSort: (val) => {
        if (val === "DESC") {
          setFilters((pre) => ({ ...pre, sortQuery: "-createdAt" }));
        } else {
          setFilters((pre) => ({ ...pre, sortQuery: "createdAt" }));
        }
      },
      isSearchFilter: false,
      onSearchFilter: (val) => {
        console.log(val, "range valueee");
      },
      isOption: "range-picker",
    },
    {
      _id: 5,
      name: "Status",
      align: "left",
      isFilter: true,
      isFilterSearch: false,
      onFilter: (val) => {
        if (val?.length > 0 && val?.length === 1) {
          setFilters((pre) => ({
            ...pre,
            status: val?.map((item) => item?.value),
            page: 1,
          }));
        } else {
          setFilters((pre) => {
            delete pre?.status;
            return { ...pre };
          });
        }
      },
      filterData: status_filter || [],
    },
    {
      _id: 6,
      name: "Action",
      align: "left",
    },
  ];
  const tagColors = [
    "bg-purple-100 text-purple-700 border border-purple-200",
    "bg-lime-100 text-lime-700 border border-lime-200",
    "bg-orange-100 text-orange-700 border border-orange-200",
    "bg-blue-100 text-blue-700 border border-blue-200",
    "bg-purple-100 text-purple-700 border border-purple-200",
    "bg-orange-100 text-orange-700 border border-orange-200",
    "bg-pink-100 text-pink-700 border border-pink-200",
    "bg-indigo-100 text-indigo-700 border border-indigo-200",
    "bg-teal-100 text-teal-700 border border-teal-200",
    "bg-yellow-100 text-yellow-700 border border-yellow-200",
  ];
  // Table Body Data =====================>
  const tableData = data?.data?.map((item) => {
    return {
      _id: item?._id,
      rowData: [
        {
          _id: 1,
          type: "text",
          align: "left",
          cellClass: "!min-w-[100px]",
          data: (
            <div className="w-10 h-10 rounded-full border border-gray-300 flex items-center justify-center overflow-hidden bg-white">
              {item?.adsType === "google" ? (
                <img src={GoogleLogo} className="w-full h-full object-cover" alt="preview" />
              ) : item?.adsType === "personal" && item?.type === "post-video" ? (
                <i className="fa-solid fa-video text-xl text-gray-600"></i>
              ) : item?.adsType === "personal" && item?.type === "post-photo" ? (
                <img src={item?.mediaGallery[0]?.url} className="w-10 h-10 object-contain" alt="Google" />
              ) : (
                <i className="fa-regular fa-image text-3xl text-gray-400"></i>
              )}
            </div>
          ),
        },
        {
          _id: 2,
          type: "text",
          align: "left",
          cellClass: "!min-w-[100px]",
          data:
            (
              <div
                dangerouslySetInnerHTML={{
                  __html: item?.content?.[userLang]?.title || "-",
                }}
              ></div>
            ) || "-",
        },
        // {
        //   _id: 3,
        //   type: "text",
        //   align: "left",
        //   cellClass: "!min-w-[100px]",
        //   data: (
        //     <>
        //       {item?.categoryDetails?.length > 1 ? (
        //         <Tooltip
        //           position="bottom"
        //           className=""
        //           message={
        //             <div className="text-[12px] whitespace-pre-wrap max-w-xs flex flex-wrap gap-1">
        //               {item.categoryDetails.map((it, ind) => (
        //                 <Badge
        //                   key={ind}
        //                   customColor={tagColors[ind % tagColors.length]}
        //                   label={it?.title}
        //                   className="!rounded-full !h-6"
        //                 />
        //               ))}
        //             </div>
        //           }
        //           messageClass="!bg-gradient-to-br !from-slate-600 !via-slate-500 !to-slate-500 !p-2 !rounded-lg !shadow-md border !border-gray-200"
        //         >
        //           <div className="flex items-center gap-2">
        //             <Badge
        //               customColor={tagColors[0]}
        //               label={item.categoryDetails[0]?.title}
        //               className="!rounded-full !h-6"
        //             />
        //             <span className="bg-gray-100 text-gray-800 font-bold text-xs px-2 py-1 rounded-full border border-gray-300">
        //               +{item.categoryDetails.length - 1} more
        //             </span>
        //           </div>
        //         </Tooltip>
        //       ) : (
        //         <div className="flex items-center gap-2">
        //           {item?.categoryDetails?.length === 1 ? (
        //             <Badge
        //               customColor={tagColors[0]}
        //               label={
        //                 item?.categoryDetails[0]?.content?.[userLang]?.title
        //               }
        //               className="!rounded-full !h-6"
        //             />
        //           ) : (
        //             <span className="text-gray-500 text-sm text-center">-</span>
        //           )}
        //         </div>
        //       )}
        //     </>
        //   ),
        // },
        {
          _id: 4,
          type: "text",
          align: "left",
          cellClass: "!min-w-[100px]",
          data:
            item?.adsType === "personal" ? (
              <Badge customColor={tagColors[1]} label={"Personal"} className="!rounded-full !h-6" />
            ) : (
              <Badge customColor={tagColors[4]} label={"Google"} className="!rounded-full !h-6" />
            ),
        },
        // {
        //   _id: 10,
        //   type: "text",
        //   align: "center",
        //   cellClass: "!min-w-[100px]",
        //   data: !item?.isGlobal
        //     ? item?.artistDetails?.firstName &&
        //       item?.artistDetails?.lastName &&
        //       `${item?.artistDetails?.firstName} ${item?.artistDetails?.lastName}`
        //     : "N/A",
        // },
        {
          _id: 4,
          type: "text",
          align: "left",
          cellClass: "!min-w-[100px]",
          data: item?.schedule?.startDate ? dayjs(item?.schedule?.startDate).format("DD MMM, YYYY") : "-",
        },
        {
          _id: 5,
          type: "text",
          align: "left",
          cellClass: "!min-w-[100px]",
          data: (
            <div
              className="flex gap-2 items-center cursor-pointer"
              onClick={() => {
                statusChangeHandler({
                  id: item?._id,
                  status: item?.status === "active" ? "inactive" : "active",
                });
              }}
            >
              <Badge type={item?.status === "active" ? "success" : "danger"} label={item?.status === "active" ? "Active" : "Inactive"} />
            </div>
          ),
        },
        {
          _id: 6,
          type: "action",
          align: "left",
          cellClass: "w-[5%]",
          actionData: [
            {
              _id: 1,
              name: "Edit",
              icon: "fa-regular fa-pen-to-square",
              onClick: () => {
                navigate(`/admin/manage-advertisement/${item?.slug}-${item?.uid}`);
              },
              standout: false,
            },

            {
              _id: 2,
              name: "Delete",
              icon: "fa-regular fa-trash-can",
              standout: true,
              onClick: () => {
                setDeleteModal({
                  isOpen: true,
                  data: item,
                });
              },
            },
          ],
        },
      ],
    };
  });

  //   Blog delete handler =================>
  const { mutate: deleteHandler, isPending: deletePending } = useMutation({
    mutationFn: async (payload) => {
      const res = await postDelete({
        ids: Array.isArray(payload) ? payload : [payload],
      });
      return {
        res,
        payload: Array.isArray(payload) ? payload : [payload],
      };
    },
    onSuccess: ({ res, payload }) => {
      if (res?.status === 200) {
        setDeleteModal({ isOpen: false, data: null });
        setSelectedItems([]);
        queryClient.setQueryData(["advertisement", filters, search, selectFilterItem], (state) => {
          if (state) {
            let stateData = JSON.parse(JSON.stringify(state?.data));
            stateData = (stateData || [])?.filter((item) => !payload?.includes(item?._id));
            return { ...state, data: stateData };
          }
        });

        queryClient.invalidateQueries(["advertisement", filters, search, selectFilterItem]);
      } else {
        toast.warning(res?.message || res?.error);
      }
    },
    onError: (error) => {
      console.log(error);
    },
  });

  async function postOrderingHandler(newData, oldData) {
    const changedIndices = [];

    newData.forEach((item, newIndex) => {
      const oldIndex = oldData.findIndex((o) => o._id === item._id);
      if (oldIndex !== newIndex) {
        changedIndices.push({ oldIndex, newIndex });
      }
    });

    if (changedIndices.length === 0) return;

    const { oldIndex, newIndex } = changedIndices[0];
    const firstItem = oldData[oldIndex];
    const secondItem = oldData[newIndex];

    const ordering_data = [
      { id: firstItem._id, ordering: secondItem.ordering },
      { id: secondItem._id, ordering: firstItem.ordering },
    ];

    const res = await postOrdering({ ordering_data });

    if (res?.status !== 200) {
      queryClient.setQueryData(["advertisement", filters, search, selectFilterItem], (state) => (state ? { ...state, data: oldData } : state));
      toast.warning(res?.message || res?.error);
    } else {
      queryClient.refetchQueries(["advertisement", filters, search, selectFilterItem]);
    }
  }

  function actionHandler(val) {
    switch (val) {
      case "blogDelete":
        setDeleteModal({
          isOpen: true,
          data: { _id: selectedItems },
        });
        break;

      default:
        break;
    }
  }
  const options = [
    {
      id: "blogDelete",
      icon: "fa-regular fa-trash-can",
      tooltip: "Blog Delete",
    },
  ];

  return (
    <div className="space-y-4 w-full flex flex-col pb-10">
      <div className="space-y-8">
        <div className="font-bold text-lg xl:text-3xl text-primary mb-8">
          <i className={"fas fa-bullhorn fa-lg"}></i> Advertisements
        </div>
        {/* {selectedAllFilters?.length > 0 && (
          <div className="flex gap-2 items-center flex-wrap mt-2">
            {selectedAllFilters?.map((item) => (
              <div
                key={item}
                className="flex items-center gap-2 bg-blue-100 text-blue-800 px-3 py-1 rounded-full text-sm font-medium capitalize">
                {item}
                <button
                  onClick={() => {
                    setSelectedAllFilters((prev) => prev.filter((i) => i !== item));
                    setSelectedFilter(null);
                    setSelectFilterItem({});
                  }}
                  className="text-blue-600 hover:text-red-500 focus:outline-none">
                  ×
                </button>
              </div>
            ))}
          </div>
        )} */}

        <div className="flex items-center gap-3">
          <TableControls
            limit={filters?.limit}
            totalDocs={data?.metadata?.totalDocs}
            onLimitChange={(val) => handleFilterChange("limit", val, setFilters)}
            onSearch={(val) => {
              setKeyword(val);
              handleFilterChange("page", 1, setFilters);
            }}
          />
          {/* <TagFilter
            type={"post"}
            selectedFilter={selectedFilter}
            setSelectedFilter={setSelectedFilter}
            setSelectFilterItem={setSelectFilterItem}
            setSelectedAllFilters={setSelectedAllFilters}
            filterOptions={[
              { name: "Status", value: "status" },
              { name: "Date Range", value: "dateRange" },
              { name: "Category", value: "category" },
              { name: "Tags", value: "tags" },
            ]}
          /> */}
          {selectedItems?.length > 0 && (
            <div className="flex items-center gap-2">
              <ActionBar options={options} onChange={actionHandler} />
              <span className="flex items-center rounded-full bg-secondary text-surface-01 text-xs px-3 py-1 gap-2">
                {selectedItems?.length} Selected
                <button onClick={() => setSelectedItems([])} type="button" className="cursor-pointer">
                  <i className="fa-fw fa-light fa-xmark"></i>
                </button>
              </span>
            </div>
          )}
          <div className="relative ml-auto">
            <Button buttonIcon={"fa-regular fa-plus"} buttonLabel={"Create New"} buttonFunction={() => navigate("/admin/manage-advertisement")} />
          </div>
        </div>
        {/* <FilterTags /> */}
      </div>

      <Table
        tableHeadData={tableHeadData}
        tableData={tableData}
        totalDataCount={data?.metadata?.totalDocs}
        isLoder={isLoading}
        pageCount={data?.metadata?.totalPages}
        currentPage={filters?.page}
        onPageChange={(val) => {
          handleFilterChange("page", val, setFilters);
          setSelectedItems([]);
        }}
        handleOrdering={(newData, oldData) => {
          postOrderingHandler(newData, oldData);
        }}
        originalData={[...(data?.data || [])]}
        setOriginalData={(data) =>
          queryClient.setQueryData(["advertisement", filters, search, selectFilterItem], (state) => {
            if (state) {
              return { ...state, data: data };
            }
          })
        }
        isFetching={isFetching}
        isOrderingDisabled={false}
        // selectable
        selectedItems={selectedItems}
        setSelectedItems={setSelectedItems}
        tableActionDropdownContainer={"!w-48"}
        showingData={getPaginationRange(filters?.page, filters?.limit, data?.metadata?.totalDocs)}
      />
      <DeleteModal
        open={deleteModal?.isOpen}
        loading={deletePending}
        onClose={() => setDeleteModal((pre) => ({ data: null, isOpen: false }))}
        deleteHandler={() => {
          deleteHandler(deleteModal?.data?._id);
        }}
      />
    </div>
  );
};

export default Advertisement;
